module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "confirmation"
    }
  }, [(_vm.confirmation) ? _c('div', {
    staticClass: "container print"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header no-display"
  }, [_vm._v("\n        Reservation Confirmation\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "no-display"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.location_name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-4",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n                  Date: "), (_vm.confirmation.last_updated_at) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.last_updated_at)
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.confirmation.location_address) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.location_address)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.confirmation.booking_no) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s('Bookind ID: #' + _vm.confirmation.booking_no)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.confirmation.reserved_from_display && _vm.confirmation.reserved_to_display) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.reserved_from_display + ' - ' + _vm.confirmation.reserved_to_display)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "booking-table",
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.confirmation.seat_dates) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('table', {
    staticClass: "booking-table-inner",
    attrs: {
      "width": "100%"
    }
  }, _vm._l((_vm.confirmation.seat_dates), function(seat_date) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "width": "50%"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(seat_date.seat_display)
      }
    }), _vm._v(" -\n                          "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(seat_date.from_date)
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "25%"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "25%"
      },
      domProps: {
        "innerHTML": _vm._s(seat_date.seat_amount_display)
      }
    })])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.confirmation.food_package) ? _c('tr', [_c('td', [_c('div', {
    staticClass: "product-title"
  }, [_vm._v("\n                      Food\n                    ")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.food_package)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.food_package_desc)
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.food_package_amount_disp)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.tax_amount_display) ? _c('tr', [_c('td'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.tax_amount_display)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.service_fee_amount_display) ? _c('tr', [_c('td'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.service_fee_amount_display)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.total_amount_display) ? _c('tr', [_c('td'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.total_amount_display)
    }
  })]) : _vm._e()]), _c('br'), _c('br'), _vm._v(" "), (_vm.confirmation.location_terms) ? _c('div', {
    staticClass: "terms no-display"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.location_terms)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.confirmation.location_description) ? _c('div', {
    staticClass: "desc no-display"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation.location_description)
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "no-print text-big text-center"
  }, [_vm._v("\n          Your reservation has been submitted."), _c('br'), _c('br'), _vm._v("\n\n          You will receive an email and a text with your reservation details "), (_vm.confirmation.email) ? _c('span', [_vm._v("at " + _vm._s(_vm.confirmation.email))]) : _vm._e(), _vm._v("."), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-print"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('a', {
    staticClass: "btn el-button btn-primary mt-5",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.doPrint()
      }
    }
  }, [_vm._v("Print Receipt")]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('a', {
    staticClass: "btn  el-button  btn-success mt-5",
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('a', {
    staticClass: "btn el-button  btn-primary mt-5",
    attrs: {
      "href": "#/dashboard"
    }
  }, [_vm._v("Done")]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title no-display"
  }, [_c('img', {
    staticClass: "inline-text",
    attrs: {
      "alt": "OpenCabana",
      "src": "https://api.opencabana.com/images/logo.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("OpenCabana")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("\n                    Description\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("\n                    Amount\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Tax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Service Fee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6578d01b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/reservation/confirmation.vue
// module id = 599
// module chunks = 2